import React from 'react';

const Spinner: React.FC = () => (
  <div className="size-8 animate-spin rounded-full border-[0.25em] border-transparent border-t-blue-400" />
);

export default Spinner;
